/* DAF Tema — theme.js */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Para biçimi (mağazanın money_format'ına göre) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Çekmeceler ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var panel = $('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-modal.is-open') && !$('.story-viewer.is-open')) document.body.classList.remove('no-scroll');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openDrawer($('#MenuDrawer')); return; }
    if (t.closest('[data-cart-open]') && theme.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); openDrawer($('#CartDrawer')); return; }
    var closer = t.closest('[data-drawer-close]');
    if (closer) {
      var d = closer.closest('.drawer');
      if (closer.tagName === 'A' && closer.getAttribute('href') && closer.getAttribute('href') !== '#') { closeDrawer(d); return; }
      e.preventDefault();
      closeDrawer(d);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
  });

  /* ---------- Yapışkan header ---------- */
  (function () {
    var header = $('[data-header]');
    if (!header) return;
    var wrap = header.closest('.section-header') || header.parentElement;
    var mode = header.dataset.sticky;
    if (mode === 'none') return;
    wrap.classList.add('is-sticky');
    if (mode !== 'on-scroll-up') return;
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > lastY && y > wrap.offsetHeight + 100) wrap.classList.add('is-hidden');
      else wrap.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  })();

  /* ---------- Arama ---------- */
  var searchModal = $('[data-search-modal]');
  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var input = $('input[type="search"]', searchModal);
    setTimeout(function () { input && input.focus(); }, 30);
  }
  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]') || e.target === searchModal) closeSearch();
  });
  (function () {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;
    var timer, controller;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        fetch(theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[limit]=6&resources[options][prefix]=last', controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('.shopify-section') || doc.body;
            results.innerHTML = sec.innerHTML;
          })
          .catch(function () {});
      }, 250);
    });
  })();

  /* ---------- Sepet (AJAX) ---------- */
  function refreshCart(openAfter) {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    return fetch(theme.routes.root + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();
        if (data['cart-drawer']) {
          var current = $('#CartDrawer');
          var fresh = parser.parseFromString(data['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          if (current && fresh) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen || openAfter) openDrawer(current);
          }
        }
        if (data['cart-icon-bubble']) {
          var bubble = $('#cart-icon-bubble');
          var doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var inner = doc.querySelector('.shopify-section');
          if (bubble && inner) {
            $$('.cart-count, .visually-hidden', bubble).forEach(function (n) { n.remove(); });
            bubble.insertAdjacentHTML('beforeend', inner.innerHTML);
          }
        }
      });
  }
  theme.refreshCart = refreshCart;

  function cartChange(line, quantity) {
    var lineEl = document.querySelector('[data-line="' + line + '"]');
    if (lineEl) lineEl.style.opacity = '.5';
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) toast(res.description);
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCart(false);
      })
      .catch(function () { toast(theme.strings.error); if (lineEl) lineEl.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('[data-quantity]');
      var input = $('input', wrap);
      var min = parseInt(input.min || '0', 10);
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var val = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
      val = Math.max(min, Math.min(max, val));
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); cartChange(parseInt(remove.dataset.lineRemove, 10), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) cartChange(parseInt(input.dataset.lineQty, 10), parseInt(input.value || '0', 10));
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(theme.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });
  document.addEventListener('submit', function (e) {
    var df = e.target.closest('[data-discount-form]');
    if (df) {
      e.preventDefault();
      var code = df.querySelector('input').value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(theme.routes.cart);
    }
  });

  /* Ürün formu: sepete ekle / şimdi satın al */
  function addToCart(form, buyNow) {
    var btn = buyNow ? $('[data-buy-now]', form) : ($('[data-add-button]', form) || $('button[type="submit"]', form));
    var errorBox = $('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    var fd = new FormData(form);
    // form="" ile bağlı dış alanlar (adet) FormData'ya otomatik girer
    return fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var msg = res.description || res.message || theme.strings.error;
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else toast(msg);
          return;
        }
        if (buyNow) { window.location.href = '/checkout'; return; }
        if (theme.cartType === 'drawer' && $('#CartDrawer')) return refreshCart(true);
        if (theme.cartType === 'page') { window.location.href = theme.routes.cart; return; }
        toast(theme.strings.added);
        return refreshCart(false);
      })
      .catch(function () { toast(theme.strings.error); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.js-product-form');
    if (!form) return;
    e.preventDefault();
    addToCart(form, false);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]');
    if (!b) return;
    e.preventDefault();
    addToCart(b.closest('form'), true);
  });

  /* ---------- Ürün sayfası: varyant + galeri ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var gallery = $('[data-gallery]', root);
    var track = gallery && $('[data-gallery-track]', gallery);
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var dots = gallery ? $$('[data-gallery-dots] button', gallery) : [];
    var slides = track ? $$('.gallery__slide', track) : [];

    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reducedMotion ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var active = thumbs[i];
      if (active && active.parentElement) {
        var p = active.parentElement;
        p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
      }
      slides.forEach(function (s, n) { if (n !== i) $$('video', s).forEach(function (v) { v.pause(); }); });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumb, 10)); }); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      var cur = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, cur() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, cur() + 1)); });
    }

    if (!product) return;
    var form = $('form.js-product-form', root);
    var idInput = form && $('[data-variant-id]', form);
    var optionCount = product.options.length;

    function selectedOptions() {
      var values = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = $('input[data-option-index="' + i + '"]:checked', root);
        var select = $('select[data-option-index="' + i + '"]', root);
        values.push(checked ? checked.value : select ? select.value : null);
      }
      return values;
    }
    function findVariant(values) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }
    function markAvailability(values) {
      for (var i = 0; i < optionCount; i++) {
        $$('input[data-option-index="' + i + '"]', root).forEach(function (input) {
          var test = values.slice(); test[i] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, n) { return o === test[n]; });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
        $$('select[data-option-index="' + i + '"] option', root).forEach(function (opt) {
          var test = values.slice(); test[i] = opt.value;
          var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, n) { return o === test[n]; }); });
          opt.textContent = opt.value + (ok ? '' : ' — ' + theme.strings.soldOut);
        });
      }
    }
    function updateVariant() {
      var values = selectedOptions();
      var variant = findVariant(values);
      markAvailability(values);
      $$('fieldset.variant-picker__option', root).forEach(function (fs) {
        var c = $('input:checked', fs), s = $('[data-selected-value]', fs);
        if (c && s) s.textContent = c.value;
      });
      var addBtn = $('[data-add-button]', root);
      var addLabel = $('[data-add-label]', root);
      var buyNow = $('[data-buy-now]', root);
      var stickyBtn = $('[data-sticky-add]');
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = theme.strings.unavailable;
        if (buyNow) buyNow.disabled = true;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? (addLabel.dataset.label || theme.strings.addToCart) : theme.strings.soldOut;
      if (buyNow) {
        buyNow.disabled = !variant.available;
        var buyLabel = $('[data-buy-label]', buyNow);
        if (buyLabel) buyLabel.textContent = variant.available ? (buyLabel.dataset.label || buyLabel.textContent) : theme.strings.soldOut;
      }
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      var priceHtml = renderPrice(variant);
      $$('[data-product-price] [data-price], [data-sticky-price] [data-price]').forEach(function (el) {
        var badge = $('.badge', el);
        el.outerHTML = priceHtml(badge !== null);
      });

      var sku = $('[data-sku]', root);
      if (sku) { sku.hidden = !variant.sku; $('span', sku).textContent = variant.sku || ''; }

      if (variant.featured_media && slides.length) {
        var idx = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(variant.featured_media.id); });
        if (idx > -1) goTo(idx);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    function renderPrice(variant) {
      return function (withBadge) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var html = '<div class="price' + (onSale ? ' price--on-sale' : '') + '" data-price>';
        html += '<span class="' + (onSale ? 'price__sale' : '') + '">' + formatMoney(variant.price) + '</span>';
        if (onSale) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          if (withBadge) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
            var text = (theme.saleBadgeText || '[percentage]').replace('[percentage]', pct);
            html += '<span class="badge badge--sale">' + text + '</span>';
          }
        }
        html += '</div>';
        return html;
      };
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) updateVariant();
    });
    markAvailability(selectedOptions());

    /* Yapışkan sepete ekle */
    var sticky = $('[data-sticky-atc]');
    var mainBtn = $('[data-add-button]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(mainBtn);
    }

    /* Tamamlayıcı ürünler */
    var comp = $('[data-complementary]', root);
    if (comp) {
      fetch(comp.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recommendations] .grid');
        if (grid) comp.innerHTML = grid.outerHTML;
      }).catch(function () {});
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* Benzer ürünler */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* Paylaş */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]');
    if (!b) return;
    var url = b.dataset.shareUrl, title = b.dataset.shareTitle;
    if (navigator.share) navigator.share({ title: title, url: url }).catch(function () {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast('Bağlantı kopyalandı'); });
  });

  /* ---------- Kaydırıcılar ---------- */
  function initSlider(wrap) {
    var track = $('[data-slider-track]', wrap);
    if (!track) return;
    var prev = $('[data-slider-prev]', wrap), next = $('[data-slider-next]', wrap);
    var dotsWrap = $('[data-slider-dots]', wrap);
    var items = Array.prototype.slice.call(track.children);
    function step() { return items[1] ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
    function pages() { var s = step(); return s ? Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / s) + 1) : 1; }
    function current() { var s = step(); return s ? Math.round(track.scrollLeft / s) : 0; }
    function scrollable() { return track.scrollWidth - track.clientWidth > 4; }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (!scrollable()) return;
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (i + 1) + '. slayt');
        (function (n) { b.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); }); })(i);
        dotsWrap.appendChild(b);
      }
      update();
    }
    function update() {
      var c = current();
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dotsWrap) $$('button', dotsWrap).forEach(function (b, i) { b.setAttribute('aria-current', i === c ? 'true' : 'false'); });
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
    update();

    var delay = parseFloat(wrap.dataset.autoplay || '0');
    if (delay && !reducedMotion) {
      var paused = false, timer;
      wrap.addEventListener('mouseenter', function () { paused = true; });
      wrap.addEventListener('mouseleave', function () { paused = false; });
      wrap.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      timer = setInterval(function () {
        if (paused || document.hidden || !scrollable()) return;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, delay * 1000);
    }
  }
  $$('[data-slider]').forEach(initSlider);

  /* ---------- Video kartları ---------- */
  (function () {
    var cards = $$('[data-video-card]');
    if (!cards.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var card = en.target, v = $('video', card);
        if (!v) return;
        if (en.isIntersecting) {
          if (card.hasAttribute('data-autoplay') && !card.dataset.userPaused && !reducedMotion) {
            v.muted = card.dataset.unmuted ? v.muted : true;
            v.play().then(function () { card.classList.add('is-playing'); }).catch(function () {});
          }
        } else if (!v.paused) { v.pause(); card.classList.remove('is-playing'); }
      });
    }, { threshold: 0.4 }) : null;
    cards.forEach(function (card) {
      var v = $('video', card), btn = $('[data-video-toggle]', card);
      if (!v) return;
      if (io) io.observe(card);
      function toggle() {
        if (v.paused || v.muted) {
          cards.forEach(function (c) { if (c !== card) { var o = $('video', c); if (o && !o.muted) { o.muted = true; } } });
          v.muted = false; card.dataset.unmuted = '1';
          if (v.paused) v.currentTime = v.currentTime || 0;
          v.play().then(function () { card.classList.add('is-playing'); }).catch(function () {});
          delete card.dataset.userPaused;
        } else {
          v.pause(); card.dataset.userPaused = '1'; card.classList.remove('is-playing');
        }
      }
      if (btn) btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      v.addEventListener('play', function () { if (!v.muted) card.classList.add('is-playing'); });
    });
  })();

  /* ---------- Önce / Sonra ---------- */
  $$('[data-compare]').forEach(function (el) {
    var input = $('[data-compare-input]', el);
    if (!input) return;
    input.addEventListener('input', function () { el.style.setProperty('--pos', input.value + '%'); });
  });

  /* ---------- Hikâyeler ---------- */
  (function () {
    var lists = $$('[data-stories]');
    if (!lists.length) return;
    lists.forEach(function (list) {
      var section = list.closest('.shopify-section') || document;
      var viewer = $('[data-story-viewer]', section);
      if (!viewer) return;
      var users = $$('li', list).map(function (li) {
        var tpl = $('template[data-story-template]', li);
        var node = tpl ? tpl.content.firstElementChild : null;
        return {
          btn: $('.story-bubble', li),
          name: node ? node.dataset.storyUser : '',
          avatar: node ? node.dataset.storyAvatar : '',
          items: node ? $$('[data-story-item]', node) : []
        };
      });
      var duration = parseFloat(list.dataset.duration || '10') * 1000;
      var media = $('[data-story-media]', viewer), bars = $('[data-story-bars]', viewer);
      var nameEl = $('[data-story-name]', viewer), avatarEl = $('[data-story-avatar-img]', viewer);
      var u = 0, s = 0, timer, raf, startT, video;

      function stop() { clearTimeout(timer); cancelAnimationFrame(raf); if (video) { video.pause(); video = null; } }
      function close() {
        stop();
        viewer.classList.remove('is-open');
        media.innerHTML = '';
        if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
        if (users[u] && users[u].btn) users[u].btn.focus();
      }
      function progress(el, total) {
        startT = performance.now();
        (function tick(now) {
          var p = Math.min(1, ((now || performance.now()) - startT) / total);
          if (video && video.duration) p = video.currentTime / video.duration;
          el.style.width = (p * 100) + '%';
          if (p < 1) raf = requestAnimationFrame(tick);
        })();
      }
      function show() {
        stop();
        var user = users[u];
        if (!user || !user.items.length) { close(); return; }
        if (user.btn) user.btn.classList.add('is-seen');
        nameEl.textContent = user.name;
        if (user.avatar) { avatarEl.src = user.avatar; avatarEl.hidden = false; } else avatarEl.hidden = true;
        bars.innerHTML = user.items.map(function (_, i) {
          return '<div class="story-viewer__bar"><span style="width:' + (i < s ? 100 : 0) + '%"></span></div>';
        }).join('');
        var item = user.items[s].cloneNode(true);
        media.innerHTML = '';
        media.appendChild(item);
        item.style.position = 'absolute'; item.style.inset = '0';
        var bar = $$('.story-viewer__bar span', bars)[s];
        video = $('video', item);
        if (video) {
          video.removeAttribute('controls');
          video.playsInline = true;
          video.preload = 'auto';
          video.addEventListener('ended', nextStory);
          video.play().catch(function () { video.muted = true; video.play().catch(function () {}); });
          progress(bar, 15000);
          timer = setTimeout(function () { if (video && (!video.duration || isNaN(video.duration))) nextStory(); }, 15000);
        } else {
          var img = $('img', item);
          if (img) img.loading = 'eager';
          progress(bar, duration);
          timer = setTimeout(nextStory, duration);
        }
      }
      function nextStory() {
        if (s < users[u].items.length - 1) s++;
        else if (u < users.length - 1) { u++; s = 0; }
        else { close(); return; }
        show();
      }
      function prevStory() {
        if (s > 0) s--;
        else if (u > 0) { u--; s = 0; }
        show();
      }
      list.addEventListener('click', function (e) {
        var b = e.target.closest('[data-story-open]');
        if (!b) return;
        u = parseInt(b.dataset.storyOpen, 10); s = 0;
        viewer.classList.add('is-open');
        document.body.classList.add('no-scroll');
        show();
      });
      $('[data-story-next]', viewer).addEventListener('click', nextStory);
      $('[data-story-prev]', viewer).addEventListener('click', prevStory);
      $('[data-story-close]', viewer).addEventListener('click', close);
      viewer.addEventListener('click', function (e) { if (e.target === viewer) close(); });
      document.addEventListener('keydown', function (e) {
        if (!viewer.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') nextStory();
        if (e.key === 'ArrowLeft') prevStory();
      });
    });
  })();

  /* ---------- Hotspot ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hotspot-toggle]');
    $$('.hotspot.is-open').forEach(function (h) {
      if (!t || h !== t.closest('.hotspot')) { h.classList.remove('is-open'); var b = $('[data-hotspot-toggle]', h); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
    if (t) {
      var h = t.closest('.hotspot');
      var open = h.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  /* ---------- Sekmeler ---------- */
  $$('[data-tabs]').forEach(function (root) {
    var btns = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, n) { x.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
        panels.forEach(function (p, n) { p.hidden = n !== i; });
      });
    });
  });

  /* ---------- Koleksiyon filtreleri (AJAX) ---------- */
  (function () {
    var container = $('[data-facets-container]');
    if (!container) return;
    var sectionId = container.dataset.section;
    function render(url, push) {
      var results = $('[data-results]', container);
      if (results) results.classList.add('is-loading');
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-facets-container]');
        if (fresh) { container.innerHTML = fresh.innerHTML; initReveal(container); }
        if (push) { u.searchParams.delete('section_id'); history.pushState({ facets: true }, '', u.toString()); }
      }).catch(function () { window.location.href = url; });
    }
    function formUrl(form) {
      var params = new URLSearchParams(new FormData(form));
      // boş fiyat alanlarını gönderme
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      return form.action.split('?')[0] + '?' + params.toString();
    }
    container.addEventListener('change', function (e) {
      var form = e.target.closest('[data-facets-form]');
      if (!form) return;
      if (e.target.type === 'number') return;
      render(formUrl(form), true);
    });
    container.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-facets-form]');
      if (!form) return;
      e.preventDefault();
      render(formUrl(form), true);
    });
    container.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-facet-link]');
      if (!a) return;
      e.preventDefault();
      render(a.href, true);
      window.scrollTo({ top: container.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
    });
    document.addEventListener('click', function (e) {
      $$('details[data-facet][open]', container).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    window.addEventListener('popstate', function (e) { if (e.state && e.state.facets) render(window.location.href, false); });
  })();

  /* ---------- Giriş / şifre kurtarma ---------- */
  (function () {
    var rec = $('[data-recover]'), log = $('[data-login]');
    if (!rec || !log) return;
    function sync() { var r = window.location.hash === '#recover'; rec.hidden = !r; log.hidden = r; }
    $$('[data-recover-toggle]').forEach(function (a) { a.addEventListener('click', function () { setTimeout(sync, 0); }); });
    window.addEventListener('hashchange', sync);
    if ($('.form__message--error', rec) || $('.form__message--success', rec)) window.location.hash = '#recover';
    sync();
  })();

  /* Adres formu ülke seçimi */
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });

  /* ---------- Kargo takip ---------- */
  $$('[data-track-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = f.querySelector('input').value.trim();
      if (n) window.open(f.dataset.trackUrl + encodeURIComponent(n), '_blank', 'noopener');
    });
  });

  /* ---------- Okuma ilerlemesi ---------- */
  (function () {
    var bar = $('[data-scroll-progress]');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }, { passive: true });
  })();

  /* ---------- Görünür olunca animasyon ---------- */
  function initReveal(ctx) {
    var els = $$('.reveal:not(.is-visible)', ctx);
    if (!document.body.classList.contains('has-animations') || !('IntersectionObserver' in window) || reducedMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  initReveal(document);
  window.addEventListener('pageshow', function () { initReveal(document); });

  /* Tema düzenleyici desteği */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    $$('[data-slider]', e.target).forEach(initSlider);
    $$('[data-product]', e.target).forEach(initProduct);
  });
})();
